const translations = {
  "en": {
    "AI Stock Picks": "AI Stock Picks",
    "Buy price, sell price, why": "Buy price, sell price, why",
    "Data Access": "Data Access",
    "Delayed / Standard data": "Delayed",
    "Earnings Plays": "Earnings Plays",
    "Included. Unused credits roll over to the next month automatically": "Unused credits are automatically carried over to the next month (Yearly subscribers only).",
    "IPO Strategies": "IPO Strategies",
    "Lifetime Credits": "Lifetime Credits",
    "Manual Entry only": "Manual Updates",
    "Monthly Credits": "Monthly Credits",
    "Portfolio Sync": "Portfolio Sync",
    "Pre-earnings signals": "Pre-earnings signals",
    "Real-time + Institutional Depth": "Real-time + Institutional Depth",
    "Real-time Smart Search": "Real-time Smart Search",
    "Rollover": "Credit Rollover",
    "Unlimited + Export Capabilities": "Unlimited + Export Capabilities",
    "Unlimited Auto-Sync": "Unlimited Auto-Sync",
    "Unused credits expire monthly": "Unused credits are automatically carried over to the next month (Yearly subscribers only).",
    "What to buy, which to skip": "What to buy, which to skip"
  },
  "zh-tw": {
    "AI Stock Picks": "AI 股票推薦",
    "Buy price, sell price, why": "買入價，賣出價，為什麼",
    "Data Access": "資料存取",
    "Delayed / Standard data": "延遲",
    "Earnings Plays": "財報交易策略",
    "Included. Unused credits roll over to the next month automatically": "未使用點數自動月度結轉（限年付訂閱者）",
    "IPO Strategies": "IPO策略",
    "Lifetime Credits": "終身點數",
    "Manual Entry only": "手動更新",
    "Monthly Credits": "每月點數",
    "Portfolio Sync": "投資組合同步",
    "Pre-earnings signals": "財報前的訊號",
    "Real-time + Institutional Depth": "即時 + 機構深度",
    "Real-time Smart Search": "即時智慧搜尋",
    "Rollover": "點數結轉",
    "Unlimited + Export Capabilities": "無限 + 輸出功能",
    "Unlimited Auto-Sync": "無限自動同步",
    "Unused credits expire monthly": "未使用點數自動月度結轉（限年付訂閱者）",
    "What to buy, which to skip": "買什麼、跳過什麼"
  }
};

export default translations;
